module.exports = __webpack_public_path__ + "img/main-content-default-desktop.fe3fa0fe.svg";